// src/components/Footer.tsx

import * as React from 'react';
import { AppBrandLogo } from './AppBrandLogo';

export const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-mp-bg">
      <div className="w-full px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <AppBrandLogo size="xl" />
            <p className="text-mp-muted font-body text-sm leading-relaxed max-w-xs">
              The ultimate destination for classic Porsche enthusiasts and collectors.
            </p>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 gap-8">
            <nav className="flex flex-col gap-3">
              <a href="https://mynextclassic.net/auktionsplattform-oldtimer-ueber-my-next-classic/" target="_blank" rel="noopener noreferrer" className="text-mp-muted font-mono text-xs hover:text-mp-text transition-colors">
                About Us
              </a>
              <a href="https://mynextclassic.net/impressum/" target="_blank" rel="noopener noreferrer" className="text-mp-muted font-mono text-xs hover:text-mp-text transition-colors">
                Imprint
              </a>
            </nav>
            <nav className="flex flex-col gap-3">
              <a href="https://mynextclassic.net/oldtimer-auktion-agb/" target="_blank" rel="noopener noreferrer" className="text-mp-muted font-mono text-xs hover:text-mp-text transition-colors">
                Terms of Service
              </a>
              <a href="https://mynextclassic.net/online-auktionsplattform-fuer-oldtimer-und-youngtimer-datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" className="text-mp-muted font-mono text-xs hover:text-mp-text transition-colors">
                Privacy Policy
              </a>
            </nav>
          </div>
        </div>

      </div>
    </footer>
  );
};
